import service from "@/store/services/invitaciones-service";

const state = {
  list: {},
  invitacion: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, invitacion) => {
    state.invitacion = invitacion;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then((invitacion) => {
      commit("SET_RESOURCE", invitacion);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then((invitacion) => {
      commit("SET_RESOURCE", invitacion);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then((invitacion) => {
      commit("SET_RESOURCE", invitacion);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.pagination.total,
  invitacion: (state) => state.invitacion,
  dropdown: (state) => {
    /*  state.list.map((invitacion) => console.log(invitacion)); */
    return state.list.map((invitacion) => ({
      id: invitacion.id,
      nombre: invitacion.nombre,
    }));
  },
};

const invitacions = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default invitacions;
